var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"height":"35","items":_vm.items,"disabled":_vm.disabled,"menu-props":{
    bottom: true,
    offsetY: true,
    maxHeight: 340,
    maxWidth: 250,
  },"dense":"","multiple":""},scopedSlots:_vm._u([{key:"selection",fn:function(){return [_c('div')]},proxy:true},{key:"prepend-inner",fn:function(){return [_c('div',{staticClass:"font-weight-bold mt-2"},[_vm._v(_vm._s(_vm.label))])]},proxy:true},{key:"item",fn:function({ item }){return [_vm._t("item",function(){return [_c('span',{key:item},[_vm._v(_vm._s(item))])]},{"item":item})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }